export const selectStep = ({ auth }) => auth.step;
export const selectUsername = ({ auth }) => auth.username;
export const selectPassword = ({ auth }) => auth.password;
export const selectSelectedMFA = ({ auth }) => auth.selectedMFA;
export const selectOTP = ({ auth }) => auth.otp;
export const selectIsLoading = ({ auth }) => auth.isLoading;
export const selectIsAuthenticated = ({ auth }) => auth.isAuthenticated;
export const selectAuthError = ({ auth }) => auth.error;
export const selectSignInServerError = ({ auth }) => auth.error;
export const selectMFAServerError = ({ auth }) => auth.error;
export const selectOTPServerError = ({ auth }) => auth.error;
export const selectFieldErrors = ({ auth }) => auth.fieldErrors || {};
export const selectLockoutModalOpen = ({ auth }) => Boolean(auth.lockoutModalOpen);
export const selectMFAOptions = ({ auth }) => auth.mfaOptions || [];
export const selectDefaultMFAOption = ({ auth }) => (auth.mfaOptions || [])[0];
export const selectAuthorizeResponse = ({ auth }) => auth.authorizeResponse;
export const selectServerErrorModalOpen = ({ auth }) => Boolean(auth.serverErrorModalOpen);
export const selectTimeoutModalOpen = ({ auth }) => Boolean(auth.timeoutModalOpen);
export const selectUniqueIdentifier = ({ auth }) => auth.uniqueIdentifier || null;
export const selectAppName = ({ auth }) => auth.appName || null;
export const selectRequestId = ({ auth }) => auth.requestId || null;
export const selectClientId = ({ auth }) => auth.clientId || '';
export const selectAgencyId = ({ auth }) => auth.agencyId || '';
export const selectAppUrl = ({auth}) => auth.appUrl || null;
export const selectUserDetails = ({ auth }) => auth.userDetails;
export const selectAuthType = (state) => state.auth.authType;
export const selectUtmParams = ({ auth }) => auth.utmParams;
